import { createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex-colum h-100" }
const _hoisted_2 = { class: "d-flex justify-content-between bd-highlight mb-3" }
const _hoisted_3 = {
  class: "align-self-center mb-3",
  style: {"height":"30px"}
}
const _hoisted_4 = {
  class: "input-group align-self-center ms-auto p-2 bd-highlight",
  style: {"width":"40%"}
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("option", {
  selected: "",
  value: ""
}, "选择试卷类型", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("option", { value: "system" }, "系统", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("option", { value: "meal" }, "项目", -1)
const _hoisted_8 = [
  _hoisted_5,
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = { class: "table table-bordered table-striped table-sm member-list" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"50px"} }, "序号"),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"100px"} }, "题目类型"),
    /*#__PURE__*/_createTextVNode(),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"300px"} }, "标题"),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"100px"} }, "判断题数量"),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"100px"} }, "单选题数量"),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"100px"} }, "多选题数量"),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"100px"} }, "优秀正确率"),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"100px"} }, "合格正确率"),
    /*#__PURE__*/_createElementVNode("th", null, "状态"),
    /*#__PURE__*/_createElementVNode("th", null, "添加时间"),
    /*#__PURE__*/_createElementVNode("th", null, "操作")
  ])
], -1)
const _hoisted_11 = {
  class: "mb-1 form-check form-switch",
  style: {"padding-top":"5px"}
}
const _hoisted_12 = ["checked", "onChange"]
const _hoisted_13 = { class: "flex-row flex-align-center" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_AddExamPaperDialog = _resolveComponent("AddExamPaperDialog")!
  const _component_LoadingDialog = _resolveComponent("LoadingDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.openAddQuestionDialog && $setup.openAddQuestionDialog(...args)))
          }, "添加")
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createTextVNode("   "),
          _withDirectives(_createElementVNode("select", {
            class: "form-select",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.examType) = $event)),
            onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.searchQuestionInner && $setup.searchQuestionInner(...args)))
          }, _hoisted_8, 544), [
            [_vModelSelect, _ctx.examType]
          ]),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            id: "article-keywords",
            class: "form-control",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.keywords) = $event)),
            placeholder: "标题"
          }, null, 512), [
            [_vModelText, _ctx.keywords]
          ]),
          _createElementVNode("button", {
            class: "btn btn-outline-secondary",
            type: "button",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => ($setup.searchQuestionInner && $setup.searchQuestionInner(...args)))
          }, "搜索")
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("table", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.dataList, (value, idx) => {
              return (_openBlock(), _createElementBlock("tr", { key: idx }, [
                _createElementVNode("td", null, _toDisplayString(50 * ($setup.nowPage - 1) + idx + 1), 1),
                _createElementVNode("td", null, _toDisplayString(value.examType === 'system'?'系统':'项目'), 1),
                _createElementVNode("td", null, _toDisplayString(value.title), 1),
                _createElementVNode("td", null, _toDisplayString(value.trueFalseQuantity = $setup.getQuestionTypeQuantity(value, "trueFalse")), 1),
                _createElementVNode("td", null, _toDisplayString(value.radioQuantity = $setup.getQuestionTypeQuantity(value, "radio")), 1),
                _createElementVNode("td", null, _toDisplayString(value.checkboxQuantity = $setup.getQuestionTypeQuantity(value, "checkbox")), 1),
                _createElementVNode("td", null, _toDisplayString(value.excellentAccuracy), 1),
                _createElementVNode("td", null, _toDisplayString(value.passAccuracy), 1),
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("input", {
                      class: "form-check-input",
                      checked: value.show,
                      onChange: ($event: any) => ($setup.updateQuestion(value)),
                      type: "checkbox",
                      role: "switch"
                    }, null, 40, _hoisted_12)
                  ])
                ]),
                _createElementVNode("td", null, _toDisplayString(value.createTime), 1),
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("img", {
                      class: "button-icon",
                      src: "/assets/ic_edit.png",
                      onClick: ($event: any) => ($setup.openEditQuestionDialog(value))
                    }, null, 8, _hoisted_14),
                    _createElementVNode("img", {
                      class: "button-icon img-margin",
                      src: "/assets/ic_trash.png",
                      onClick: ($event: any) => ($setup.deleteQuestion(value.id, value.title))
                    }, null, 8, _hoisted_15)
                  ])
                ])
              ]))
            }), 128))
          ])
        ]),
        _createVNode(_component_Pagination, {
          page: $setup.nowPage,
          max: $setup.totalPage/50,
          onLoadPage: _ctx.loadQuestionList
        }, null, 8, ["page", "max", "onLoadPage"])
      ])
    ]),
    _createVNode(_component_AddExamPaperDialog, {
      ref: "addDialogRef",
      show: _ctx.showAddDialog,
      onConfirm: $setup.editExamPaper,
      onCancel: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showAddDialog=false))
    }, null, 8, ["show", "onConfirm"]),
    _createVNode(_component_LoadingDialog, { show: _ctx.showLoadingDialog }, null, 8, ["show"])
  ], 64))
}